/*
 * 功能卡点/申请开通 通用弹窗（与 SelectDetectionTime 申请开通弹窗同风格，可复用）
 */
import React from 'react'
import { Modal } from 'antd'
import './FeatureGateModal.scss'
import { CheckCircleOutlined } from '@ant-design/icons'

export interface FeatureGateModalProps {
  visible: boolean
  onCancel: () => void
  title: string
  description?: string
  /** 为 true 时，将 description 以醒目提示区块展示（左侧强调线+背景） */
  highlightDescription?: boolean
  /** 可选：带对勾的权益/特性列表 */
  features?: string[]
  /** 可选：自定义子内容（如权益对比表），渲染在 description/features 与按钮之间 */
  children?: React.ReactNode
  primaryButton: {
    text: string
    onClick: () => void
    loading?: boolean
    disabled?: boolean
  }
  secondaryButton: { text: string; onClick: () => void }
  width?: number
  maskClosable?: boolean
  closable?: boolean
  getContainer?: false | (() => HTMLElement)
}

const FeatureGateModal: React.FC<FeatureGateModalProps> = ({
  visible,
  onCancel,
  title,
  description,
  highlightDescription = false,
  features,
  children,
  primaryButton,
  secondaryButton,
  width = 520,
  maskClosable = false,
  closable = true,
  getContainer
}) => {
  return (
    <Modal
      open={visible}
      {...(getContainer !== undefined && { getContainer })}
      wrapClassName="feature-gate-modal"
      width={width}
      centered
      mask={{ closable: maskClosable }}
      footer={null}
      onCancel={onCancel}
      closable={closable}
    >
      <div className="feature-gate-modal__content">
        <h3 className="feature-gate-modal__title">{title}</h3>
        <div className="feature-gate-modal__sparkles">
          <div className="sparkle sparkle-1" />
          <div className="sparkle sparkle-2" />
          <div className="sparkle sparkle-3" />
          <div className="sparkle sparkle-4" />
        </div>
        {description ? (
          highlightDescription ? (
            <div className="feature-gate-modal__desc-wrap feature-gate-modal__desc-wrap--highlight">
              <span className="feature-gate-modal__desc-highlight-text">
                {description}
              </span>
            </div>
          ) : (
            <p className="feature-gate-modal__desc">{description}</p>
          )
        ) : null}
        {features && features.length > 0 ? (
          <div className="feature-gate-modal__features">
            {features.map((text, i) => (
              <div key={i} className="feature-gate-modal__feature-row">
                <CheckCircleOutlined className="feature-gate-modal__check-icon" />
                <span>{text}</span>
              </div>
            ))}
          </div>
        ) : null}
        {children ? (
          <div className="feature-gate-modal__children">{children}</div>
        ) : null}
        <button
          type="button"
          className="feature-gate-modal__btn-primary"
          onClick={primaryButton.onClick}
          disabled={primaryButton.loading || primaryButton.disabled}
        >
          {primaryButton.loading ? '提交中...' : primaryButton.text}
        </button>
        <button
          type="button"
          className="feature-gate-modal__btn-secondary"
          onClick={secondaryButton.onClick}
        >
          {secondaryButton.text}
        </button>
      </div>
    </Modal>
  )
}

export default FeatureGateModal
